/* unplugin-vue-components disabled */import { render } from "./cards.vue?vue&type=template&id=2262636c&scoped=true"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"

import "./cards.vue?vue&type=style&index=0&id=2262636c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2262636c"],['__file',"src/components/cards-v2/cards.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2262636c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2262636c', __exports__)) {
    api.reload('2262636c', __exports__)
  }
  
  module.hot.accept("./cards.vue?vue&type=template&id=2262636c&scoped=true", () => {
    api.rerender('2262636c', render)
  })

}


export default __exports__